function getCssVariable(varName) {
    return getComputedStyle(document.documentElement).getPropertyValue(varName);
}

export default getCssVariable;
